import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "reactstrap";
import {
	Card,
	FormGroup,
	Alert,
	CardBody,
	CardTitle,
	CardFooter,
} from "reactstrap";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import CardContent from "@mui/material/CardContent";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { dealerProfile } from "../../redux/actions/dealerProfileAction";
import success from "../../assets/img/success.png";
import SOLogout from "../../components/Logout/SOLogout";
import failed from "../../assets/img/failed.png";
import {
	Grid,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Button,
	Accordion,
	AccordionSummary,
	AccordionDetails
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";

function DealerProfile() {
	const location = useLocation();
	const [viewDealerProfileStatus, setViewDealerProfileStatus] = useState(false);

	const [viewDealerProfileArray, setViewDealerProfileArray] = useState([]);

	const partnerloginUser = useSelector(({ login }) => login);

	const [custId, setCustId] = useState("");
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const viewDealerProfileRes = useSelector(
		({ dealerProfiles }) => dealerProfiles
	);
	const dispatch = useDispatch();

	const setViewDealerProfileFunc = () => {
		setViewDealerProfileStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				// customerId: partnerloginUser.data.customerId || "",
				customerId: 189875
			}
		};
		return dispatch(dealerProfile(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			setViewDealerProfileFunc();
		}
	}, [regenerateTokenRes.data.status]);

	const viewDealerProfileStatusFunc = () => {
		if (viewDealerProfileStatus) {
			if (viewDealerProfileRes.data.status == "Success") {
				setViewDealerProfileArray(viewDealerProfileRes.data);
				// setViewDealerProfileArray(viewDealerProfileRes.partnerloginUser.data.customerId)
				// console.log("viewDealerProfileRes", viewDealerProfileRes)
			}
			if (viewDealerProfileRes.data.status == "failed") {
				setViewDealerProfileArray(viewDealerProfileRes.data);
				if (
					viewDealerProfileRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					viewDealerProfileRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		viewDealerProfileStatusFunc();
	}, [viewDealerProfileRes.data.status]);

	return (
		<>
			<Layout>
				{/* <BackButton /> */}
				<div style={{ background: "white", borderRadius: "5px" }}>
					<Box marginLeft={3} marginRight={3} paddingBottom={2}>

						<Typography
							variant="h6"
							component="div"
							className=""
							style={{
								fontSize: "1.4rem",
								marginBottom: "1.2rem",
								color: "#013c83",
								textAlign: "center",
								fontWeight: "600"
							}}
						>
							<Col md={12}>

								{viewDealerProfileArray.customerMasterDetailsResponseVO &&
									viewDealerProfileArray.customerMasterDetailsResponseVO
										.userRole} {""}

								Details


							</Col>
						</Typography>


						<Accordion>
							<AccordionSummary
								expandIcon={<ExpandMore />}
								aria-controls="panel1a-content"
								id="panel1a-header"
							>
								<Typography style={{ color: "#013c83" }}>
									Request Registration Details
								</Typography>
							</AccordionSummary>
							{/* <Alert
						className="text-left themeBackground"
						variant="secondary"
						// fullWidth={true}
						style={{ borderRadius: "0" }}
					>
						<Typography variant="body1">
							Request Registration Details
						</Typography>
					</Alert> */}
							{/* <Box marginLeft={3} marginRight={3} paddingBottom={2}> */}
							{/* <div
							style={{
								marginTop: "2rem"
							}}
						> */}
							<AccordionDetails style={{ display: "unset" }}>
								<Typography>
									<Col md={12}>
										<Row className="detail-info row">
											<Col md={6}>Agent/Merchant ID: </Col>
											<Col md={6}>
												{viewDealerProfileArray.customerMasterDetailsResponseVO &&
													viewDealerProfileArray.customerMasterDetailsResponseVO
														.customerId}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Role:</Col>
											<Col md={6}>
												{viewDealerProfileArray.customerMasterDetailsResponseVO &&
													viewDealerProfileArray.customerMasterDetailsResponseVO
														.userRole}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Entity Type:</Col>
											<Col md={6}>
												{viewDealerProfileArray.customerMasterDetailsResponseVO &&
													viewDealerProfileArray.customerMasterDetailsResponseVO
														.entityType}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Created By:</Col>
											<Col md={6}>
												{viewDealerProfileArray.customerMasterDetailsResponseVO &&
													viewDealerProfileArray.customerMasterDetailsResponseVO
														.initiatedBy}
											</Col>
										</Row>
										<hr />
										<Row className="detail-info row">
											<Col md={6}>Modified By:</Col>
											<Col md={6}>
												{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
											</Col>
										</Row>
									</Col>
								</Typography>
							</AccordionDetails>
						</Accordion>
						{viewDealerProfileArray.customerMasterDetailsResponseVO &&
							viewDealerProfileArray.customerMasterDetailsResponseVO
								.walletList ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography style={{ color: "#013c83" }}>
											Wallet Balance
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<Table size="medium" aria-label="purchases">
											<TableHead>
												<TableRow style={{ background: "#00b9f5" }}>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Store Id
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Currency
													</TableCell>
													<TableCell
														align="center"
														style={{ fontWeight: "bold", color: "white" }}
													>
														Balance
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{viewDealerProfileArray.customerMasterDetailsResponseVO &&
													viewDealerProfileArray
														.customerMasterDetailsResponseVO.walletList &&
													[]
														.concat(
															viewDealerProfileArray
																.customerMasterDetailsResponseVO.walletList
														)
														.map((detail, i) => {
															return (
																<TableRow key={i + 1}>
																	<TableCell
																		style={{
																			width: "35%",
																			textAlign: "center"
																		}}
																	>
																		{/* {`${detail.currency} -  ${detail.balance}`}{" "} */}
																		{detail.storeId == ""
																			? "-"
																			: detail.storeId}
																	</TableCell>
																	<TableCell
																		style={{
																			width: "35%",
																			textAlign: "center"
																		}}
																	>
																		{/* {`${detail.currency} -  ${detail.balance}`}{" "} */}
																		{detail.currency == ""
																			? "-"
																			: detail.currency}
																	</TableCell>
																	<TableCell
																		style={{
																			width: "35%",
																			textAlign: "center"
																		}}
																	>
																		{detail.balance == ""
																			? "-"
																			: detail.balance}
																	</TableCell>
																</TableRow>
															);
														})}
											</TableBody>
										</Table>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}
						{/* <div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography style={{ color: "#013c83" }}>
										Wallet Balance
									</Typography>
								</AccordionSummary>

								<AccordionDetails style={{ display: "unset" }}>
									<Typography>
										<Col md={12}>
											<Row className="detail-info row">
												<Col md={6}></Col>
												<Col md={6}>
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.walletList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.walletList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.currency}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.walletList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.walletList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.currency}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />


										</Col>
									</Typography>
								</AccordionDetails>
							</Accordion>
						</div> */}
						{/* {
							viewDealerProfileArray.customerMasterDetailsResponseVO &&
								viewDealerProfileArray.customerMasterDetailsResponseVO
									.businessAccountMasterVOList ? ( */}



						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography style={{ color: "#013c83" }}>
										Company Details


									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<Typography>
										<Col md={12}>
											<Row className="detail-info row">
												<Col md={6}>Company ID: </Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.businessAccountMasterVOList &&
                                            viewDealerProfileArray.businessAccountMasterVOList.companyId

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.companyId}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.companyId}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Company Name:</Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.businessAccountMasterVOList &&
                                            viewDealerProfileArray.businessAccountMasterVOList.companyName

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.companyName}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.companyName}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Organization Type:</Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.businessAccountMasterVOList &&
                                            viewDealerProfileArray.businessAccountMasterVOList.userType

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.userType}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.userType}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Business Type:</Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.businessAccountMasterVOList &&
                                            viewDealerProfileArray.businessAccountMasterVOList.businessNature

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.businessNature}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.businessNature}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Business Phone Number:</Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.businessAccountMasterVOList &&
                                            viewDealerProfileArray.businessAccountMasterVOList.businessContactNumber

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.businessContactNumber}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return (
																	<Col md={4}>{detail.businessContactNumber}</Col>
																);
															})
														: "-"}
												</Col>
											</Row>
											<hr />

											<Row className="detail-info row">
												<Col md={6}>Outlet Infra:</Col>
												<Col md={6}>
													{viewDealerProfileArray.businessAccountMasterVOList &&
														viewDealerProfileArray.businessAccountMasterVOList
															.outletInfra
														? viewDealerProfileArray.businessAccountMasterVOList &&
														viewDealerProfileArray.businessAccountMasterVOList
															.outletInfra
														: "-"}
												</Col>
											</Row>
											<hr />

											<Row className="detail-info row">
												<Col md={6}>Outlet Infra Ownership:</Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.businessAccountMasterVOList &&
                                            viewDealerProfileArray.businessAccountMasterVOList.outletInfraOwnership

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.outletInfraOwnership}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAccountMasterVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.businessAccountMasterVOList
															)
															.map((detail, i) => {
																return (
																	<Col md={4}>{detail.outletInfraOwnership}</Col>
																);
															})
														: "-"}
												</Col>
											</Row>
											<hr />

											<Row className="detail-info row">
												<Col md={6}>VAT ID:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />

											<Row className="detail-info row">
												<Col md={6}>TAX ID:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />

											<Row className="detail-info row">
												<Col md={6}>Trade License No:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />

											<Row className="detail-info row">
												<Col md={6}>Trade License Authority:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Trade License Validity:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
										</Col>
									</Typography>
								</AccordionDetails>
							</Accordion>
						</div>
						{/* ) : (
								""
							)} */}

						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography style={{ color: "#013c83" }}>
										Dealer Address Details


									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<Typography>
										<Col md={12}>
											<Row className="detail-info row">
												<Col md={6}>Address: </Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.merchantAddressRequestVOList &&
                                            viewDealerProfileArray.merchantAddressRequestVOList.city

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.merchantAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.merchantAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.merchantOwnerAddress}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.merchantAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.merchantAddressRequestVOList
															)
															.map((detail, i) => {
																return (
																	<Col md={4}>{detail.merchantOwnerAddress}</Col>
																);
															})
														: "-"}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>District:</Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.merchantAddressRequestVOList &&
                                            viewDealerProfileArray.merchantAddressRequestVOList.state

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.merchantAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.merchantAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.state}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.merchantAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.merchantAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.state}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Thana/Upazilla:</Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.merchantAddressRequestVOList &&
                                            viewDealerProfileArray.merchantAddressRequestVOList.city

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.merchantAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.merchantAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.city}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.merchantAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.merchantAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.city}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Union/Ward:</Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.merchantAddressRequestVOList &&
                                            viewDealerProfileArray.merchantAddressRequestVOList.city

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.merchantAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.merchantAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.city}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.merchantAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.merchantAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.city}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Postal Code:</Col>
												<Col md={6}>
													{viewDealerProfileArray.merchantAddressRequestVOList &&
														viewDealerProfileArray.merchantAddressRequestVOList
															.postalCode}
												</Col>
											</Row>
										</Col>
									</Typography>
								</AccordionDetails>
							</Accordion>
						</div>




						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography style={{ color: "#013c83" }}>
										Business Address Details
									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<Typography>
										<Col md={12}>
											<Row className="detail-info row">
												<Col md={6}>Address: </Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.businessAddressRequestVOList &&
                                            viewDealerProfileArray.businessAddressRequestVOList.businessAddress

                                        } */}

													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.businessAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.businessAddress}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.businessAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.businessAddress}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Location Type::</Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.businessAddressRequestVOList &&
                                            viewDealerProfileArray.businessAddressRequestVOList.businessAddress

                                        } */}
													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.businessAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.businessAddress}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.businessAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.businessAddress}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />

											<Row className="detail-info row">
												<Col md={6}>District:</Col>
												<Col md={6}>
													{/* {viewDealerProfileArray.businessAddressRequestVOList &&
                                            viewDealerProfileArray.businessAddressRequestVOList.state

                                        } */}

													{viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray.customerMasterDetailsResponseVO
																	.businessAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.state}</Col>;
															})
														? viewDealerProfileArray.customerMasterDetailsResponseVO &&
														viewDealerProfileArray.customerMasterDetailsResponseVO
															.businessAddressRequestVOList &&
														[]
															.concat(
																viewDealerProfileArray
																	.customerMasterDetailsResponseVO
																	.businessAddressRequestVOList
															)
															.map((detail, i) => {
																return <Col md={4}>{detail.state}</Col>;
															})
														: "-"}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Thana/Upazilla:</Col>
												<Col md={6}>
													{viewDealerProfileArray.businessAddressRequestVOList &&
														viewDealerProfileArray.businessAddressRequestVOList.city}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Union/Ward:</Col>
												<Col md={6}>
													{viewDealerProfileArray.businessAddressRequestVOList &&
														viewDealerProfileArray.businessAddressRequestVOList.city}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Postal Code:</Col>
												<Col md={6}>
													{viewDealerProfileArray.businessAddressRequestVOList &&
														viewDealerProfileArray.businessAddressRequestVOList
															.postalCode}
												</Col>
											</Row>
										</Col>
									</Typography>
								</AccordionDetails>
							</Accordion>


						</div>


						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Accordion>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography style={{ color: "#013c83" }}>
										KYB Details
									</Typography>
								</AccordionSummary>
								<AccordionDetails style={{ display: "unset" }}>
									<Typography>
										<Col md={12}>
											<Row className="detail-info row">
												<Col md={6}>ACTION: </Col>
												<Col md={6}></Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Verification ID: </Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Request ID:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Request status:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Request Date:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Response ID:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Verification status:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Verification Description:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Verification Type:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Score:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Recommendation:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Confidence Level:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Verified On:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
											<hr />
											<Row className="detail-info row">
												<Col md={6}>Verified By:</Col>
												<Col md={6}>
													{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.personId : "-"
                                        } */}
												</Col>
											</Row>
										</Col>
									</Typography>
								</AccordionDetails>
							</Accordion>

						</div>
					</Box>
				</div>
			</Layout >
		</>
	);
}

export default DealerProfile;
